import React from "react";
import { withStyles } from "@mui/styles";
import { startOfDay, format, parse, addHours } from "date-fns";

import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import DatePickerInput from "../../components/datePickerInput/DatePickerInput";
import TimePickerInput from "../../components/timePickerInput/TimePickerInput";
import DropdownSelect from "../../components/dropdownSelect/DropdownSelect";
import Button from "../../components/button/Button";

const isInvalidName = (name) => !name;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function AddAvailabilityRequestForm({
  classes,
  payload,
  storePayload,
  onSubmit,
  errorMessage,
  submitting,
  teams,
  eventTypes,
  eventLocations,
  setEventLocations,
  editing,
}) {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const parseTime = (timeStr) => {
    try {
      return parse(timeStr, "HH:mm", new Date());
    } catch {
      return new Date();
    }
  };

  return (
    <div className={classes.section}>
      <SingleLineTextInput
        label="NAME"
        value={payload.name}
        onChange={(value) => storePayload({ ...payload, name: value })}
        showInvalidInput={submitAttempted && isInvalidName(payload.name)}
      />
      <DropdownSelect
        label="LOCATION"
        value={payload.eventLocation}
        items={eventLocations.map((eventLocation) => ({
          value: eventLocation,
          label: eventLocation,
        }))}
        onSelect={(eventLocation) =>
          storePayload({ ...payload, eventLocation: eventLocation })
        }
        enableAutocomplete={true}
        allowCustomInput={true}
        onSubmitNew={(value) => {
          setEventLocations([...eventLocations, value]);
          storePayload({ ...payload, eventLocation: value });
        }}
      />
      <DatePickerInput
        label="EVENT DATE"
        value={payload.eventDate ? new Date(payload.eventDate) : new Date()}
        onChange={(value) =>
          storePayload({
            ...payload,
            eventDate: startOfDay(new Date(value)).toISOString(),
          })
        }
        showInvalidInput={submitAttempted && isInvalidName(payload.eventDate)}
      />
      <TimePickerInput
        label="EVENT START TIME"
        value={payload.eventStartTime ? parseTime(payload.eventStartTime) : ""}
        onChange={(value) => {
          const start = new Date(value);
          const end = addHours(start, 1);
          storePayload({
            ...payload,
            eventStartTime: format(start, "HH:mm"),
            eventEndTime: format(end, "HH:mm"),
          });
        }}
        showInvalidInput={false}
      />
      <TimePickerInput
        label="EVENT END TIME"
        value={payload.eventEndTime ? parseTime(payload.eventEndTime) : ""}
        onChange={(value) => {
          const end = new Date(value);
          storePayload({
            ...payload,
            eventEndTime: format(end, "HH:mm"),
          });
        }}
        showInvalidInput={false}
      />
      {!editing && (
        <DropdownSelect
          label="TEAM"
          value={payload.teamId}
          items={teams.map((team) => ({
            value: team.id,
            label: team.name,
          }))}
          onSelect={(itemId) => storePayload({ ...payload, teamId: itemId })}
        />
      )}
      {!editing && (
        <DropdownSelect
          label="EVENT TYPE"
          value={payload.eventTypeId}
          items={eventTypes.map((eventType) => ({
            value: eventType.id,
            label: eventType.name,
          }))}
          onSelect={(itemId) =>
            storePayload({ ...payload, eventTypeId: itemId })
          }
        />
      )}
      {onSubmit && (
        <Button
          title="Next"
          onClick={() => {
            setSubmitAttempted(true);
            onSubmit(payload);
          }}
          submitting={submitting}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(AddAvailabilityRequestForm);
